var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({'backgroundImage': 'url(' + this.backgroundImage + ')'}),attrs:{"id":"app"}},[(!_vm.loading)?_c('router-view'):_vm._e(),_c('support',{attrs:{"id":_vm.user.id}}),_c('upgrade-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }